export default "__VITE_ASSET__BrgbNoQv__"